import styled from '@emotion/styled';

import { addComma } from '../../../../../../shared/services';

import COLOR from '../../../../../../shared/constant/colorset';
import {
  getExpectedPointGuideText,
} from '../../../../shared/utils/productDetailState';

const Container = styled.div`;
  letter-spacing: -0.5px;
`;

const TotalPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const TotalPriceSubText = styled.span`
  padding-right: 12px;
  font-size: 13px;
  font-weight: 500;
  color: ${COLOR.kurlyGray800};
  line-height: 20px;
`;

const TotalPrice = styled.span`
  font-weight: bold;
  font-size: 32px;
  color: ${COLOR.kurlyGray800};
  line-height: 36px;
`;

const TotalPriceText = styled.span`
  padding-left: 5px;
  font-size: 20px;
  font-weight: 600;
  color: ${COLOR.kurlyGray800};
  line-height: 30px;
`;

const ReserveWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
`;

const ReserveTag = styled.span`
  background-color: ${COLOR.point};
  margin: 1px 6px 0 0;
  padding: 0 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  color: ${COLOR.kurlyWhite};
  line-height: 20px;
`;

const ReservePriceText = styled.span`
  line-height: 1.45;
  color: ${COLOR.kurlyGray600};
`;

const ReservePrice = styled.span`
  line-height: 1.45;
  color: ${COLOR.kurlyGray600};
`;

const Emph = styled.strong`
  font-weight: 500;
`;

interface Props {
  loggedIn: boolean;
  totalPrice: number;
  totalPoint: number;
  isDiscountProduct: boolean;
}

export default function PurchasePriceResult({
  loggedIn,
  totalPrice,
  totalPoint,
  isDiscountProduct,
}: Props) {
  const expectedPointGuide = getExpectedPointGuideText(isDiscountProduct);

  return (
    <Container>
      <TotalPriceWrapper>
        <TotalPriceSubText>총 상품금액 :</TotalPriceSubText>
        <TotalPrice>{addComma(totalPrice)}</TotalPrice>
        <TotalPriceText>원</TotalPriceText>
      </TotalPriceWrapper>
      <ReserveWrapper>
        <ReserveTag>적립</ReserveTag>
        {loggedIn ? (
          <ReservePrice>
            구매 시
            {' '}
            <Emph>{addComma(totalPoint)}원 적립</Emph>
          </ReservePrice>
        ) : (
          <ReservePriceText>{expectedPointGuide}</ReservePriceText>
        )}
      </ReserveWrapper>
    </Container>
  );
}
